import React from 'react';
import PropTypes from 'prop-types';
import { add, multiply, subtract } from 'lodash';
var Count = function Count(props) {
  var currentPage = props.currentPage,
    per = props.per,
    totalCount = props.totalCount;
  if (!currentPage || !per || !totalCount) {
    return null;
  }
  var start = add(1, multiply(per, subtract(currentPage, 1))) <= 1 ? 1 : add(1, multiply(per, subtract(currentPage, 1)));
  var end = multiply(per, currentPage) > totalCount ? totalCount : multiply(per * currentPage);
  return /*#__PURE__*/React.createElement("span", {
    className: "ui-pager-count"
  }, "".concat(start, "-").concat(end, " of ").concat(totalCount));
};
Count.propTypes = {
  currentPage: PropTypes.number,
  per: PropTypes.number,
  totalCount: PropTypes.number
};
Count.defaultProps = {
  currentPage: null,
  per: null,
  totalCount: null
};
export default Count;